/* global bsBreakpoints */
window.addEventListener("load", () => {
  const switchLangBloc = document.querySelector(".switch__lang__list") || null;
  let langues;

  if (switchLangBloc) {
    langues = switchLangBloc.querySelectorAll("li");
  }

  const switchLang = () => {
    switchLangBloc.querySelectorAll("a").forEach((item) => {
      item.addEventListener("click", (e) => {
        if (
          document.querySelector(".links").classList.contains("links--display")
        ) {
          document.querySelector(".links").classList.remove("links--display");
          return true;
        } else {
          e.preventDefault();
          document.querySelector(".links").classList.add("links--display");
        }
        if (bsBreakpoints.detectBreakpoint() === "xSmall") {
          const navReturn = document.querySelector(".responsive-return");
          navReturn.classList.toggle("responsive-return--active");
          navReturn.addEventListener("click", () => {
            switchLangBloc.classList.remove(
              "language-switcher-language-url--active"
            );
            document.querySelector(".links").classList.remove("links--display");
            navReturn.classList.remove("responsive-return--active");
          });
          let linksH = 0;
          langues.forEach((lang, index) => {
            const h = lang.offsetHeight;
            linksH += linksH + h;
          });
          switchLangBloc.classList.toggle(
            "language-switcher-language-url--active"
          );
        }
      });
    });
  };

  const respSwitch = () => {
    if (
      bsBreakpoints.detectBreakpoint() === "xSmall" ||
      bsBreakpoints.detectBreakpoint() === "medium"
    ) {
      const menuResp = document.querySelector(".menu-level-0 ");
      menuResp.appendChild(switchLangBloc);
    }
  };

  /**
   * @description A11Y SwitchLang
   * @param {boolean}
   * @constructor
   */
  const A11Y = () => {
    langues.forEach((lang) => {
      const hasPopup = lang.querySelector("a");
      const isActive = hasPopup.classList.contains("is-active");
      const srOnly = hasPopup.innerText;

      if (isActive) {
        hasPopup.setAttribute("aria-haspopup", true);
      }
      hasPopup.insertAdjacentHTML(
        "afterbegin",
        `${
          isActive === true
            ? `<span class="sr-only">Version ${srOnly} active</span>`
            : `<span class="sr-only">Version ${srOnly}</span>`
        }`
      );
    });
  };

  const init = () => {
    if (switchLangBloc) {
      switchLang();
      A11Y();
    }
  };

  init();
});
